import { Controller } from "@hotwired/stimulus"

const flippedMarketIds = new Set()

export default class extends Controller {
  static targets = ["front", "back"]
  static values = { marketId: Number }

  connect() {
    this.#setFlipped(this.#isStoredFlipped() || this.element.classList.contains("is-flipped"))
  }

  flip() {
    this.#setFlipped(true)
  }

  unflip() {
    this.#setFlipped(false)
  }

  #setFlipped(isFlipped) {
    this.element.classList.toggle("is-flipped", isFlipped)
    this.#storeFlippedState(isFlipped)

    if (this.hasFrontTarget) {
      this.frontTarget.toggleAttribute("inert", isFlipped)
      this.frontTarget.setAttribute("aria-hidden", isFlipped ? "true" : "false")
    }

    if (this.hasBackTarget) {
      this.backTarget.toggleAttribute("inert", !isFlipped)
      this.backTarget.setAttribute("aria-hidden", isFlipped ? "false" : "true")
    }
  }

  #isStoredFlipped() {
    return this.hasMarketIdValue && flippedMarketIds.has(this.marketIdValue)
  }

  #storeFlippedState(isFlipped) {
    if (!this.hasMarketIdValue) return

    if (isFlipped) {
      flippedMarketIds.add(this.marketIdValue)
    } else {
      flippedMarketIds.delete(this.marketIdValue)
    }
  }
}
